/**
 * Converts newline characters in a string into <br/> elements.
 *
 * @param {string} text  The input string, possibly containing "\n" or "\r\n"
 * @returns {Array<React.ReactNode>}  An array of strings and <br/> elements
 */
export function nl2br(text) {
	if (typeof text !== 'string') return text;

	// Split on CRLF or LF
	const lines = text.split(/\r\n|\r|\n/);

	return lines.reduce((output, line, index) => {
		// push the text for this line
		output.push(line);
		// for every line except the last, push a <br/>
		if (index < lines.length - 1) {
			output.push(<br key={index} />);
		}
		return output;
	}, []);
}
